import { render, staticRenderFns } from "./FarmerAssignModal.vue?vue&type=template&id=73757b28"
import script from "./FarmerAssignModal.vue?vue&type=script&lang=js"
export * from "./FarmerAssignModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports